import React from 'react';
import { FieldMetaState } from 'react-final-form';
import { styled } from '@linaria/react';

import { isError, isSubmitError } from '../../utils/validators';

type InputProps = {
  meta: FieldMetaState<HTMLInputElement>;
  validate?: string;
  innerRef?: React.Ref<HTMLInputElement>;
} & React.InputHTMLAttributes<HTMLInputElement>;

/**
 * @TODO reuse
 */
const withError = (props: InputProps, error: string, ok: string) => {
  const { meta, validate } = props;
  return validate === 'submit' ? (isSubmitError(meta) ? error : ok) : isError(meta) ? error : ok;
};

const Input = styled.input<{ meta: FieldMetaState<HTMLInputElement> }>`
  border-width: var(--bb-field-border-width);
  border-style: var(--bb-field-border-style);
  border-color: ${props =>
    withError(props, 'var(--bb-error-color)', 'var(--bb-field-border-color)')};
  border-radius: var(--bb-field-border-radius);
  background-color: var(--bb-field-background);
  color: var(--bb-field-color);
  padding-top: var(--bb-field-padding-top);
  padding-right: var(--bb-field-padding-right);
  padding-bottom: var(--bb-field-padding-bottom);
  padding-left: var(--bb-field-padding-left);
  width: 100%;
  font-family: inherit;
  font-size: var(--bb-field-font-size);
  line-height: var(--bb-field-line-height);
  overflow: hidden;
  text-overflow: ellipsis;
  appearance: none;
  outline: none;
  box-sizing: border-box;
  box-shadow: var(--bb-field-box-shadow);

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    appearance: none;
  }

  &::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }

  &::placeholder {
    color: var(--bb-field-placeholder);
  }

  &:hover {
    box-shadow: var(--bb-field-box-shadow--hover);
    border-color: var(--bb-field-border-color--hover);
    background-color: var(--bb-field-background--hover);
  }

  &:focus,
  &:active {
    border-color: ${props =>
      withError(props, 'var(--bb-error-color)', 'var(--bb-field-border-color--focus)')};
    box-shadow: ${props =>
      withError(
        props,
        'var(--bb-field-box-shadow--focus-error)',
        'var(--bb-field-box-shadow--focus)',
      )};
    background-color: var(--bb-field-background--focus);
  }

  &:disabled {
    border-color: var(--bb-field-border-color--disabled);
    background-color: var(--bb-field-background--disabled);
    box-shadow: var(--bb-field-box-shadow--disabled);

    &:hover {
      box-shadow: var(--bb-field-box-shadow--disabled);
    }

    &:focus,
    &:active {
      box-shadow: var(--bb-field-box-shadow--disabled);
      border-color: var(--bb-field-border-color--disabled);
      background-color: var(--bb-field-background--disabled);
    }
  }
`;

const InputComponent: React.FC<InputProps> = ({ meta = {}, disabled, innerRef, ...rest }) => (
  <Input
    {...rest}
    ref={innerRef}
    meta={meta}
    disabled={meta.submitting || disabled}
  />
);

export default InputComponent;
